import { createContext, useContext } from 'react'

export type AdminRole = 'admin' | 'editor'

// Set by AdminShell from /api/admin/me. Defaults to the narrower role so nothing admin-only flashes up first.
export const AdminRoleContext = createContext<AdminRole>('editor')

export function useIsAdmin() {
  return useContext(AdminRoleContext) === 'admin'
}
